import BillingCycle from './BillingCycle'
import RegisterUserForm from './RegisterUserForm'

const OrderSummary = ({
  activeCycle,
  changeActiveCycle,
  activeProduct,
  changeActive,
  currentPlan,
  show,
  setRegisterFormData,
  billingMemberCount,
  setBillingMemberCount,
}) => {
  return (
    <>
      <div
        className="tikbox-order tikbox-container"
        style={{ display: show ? 'block' : 'none' }}>
        <h2>Order Summary</h2>
      </div>
      <div
        className="tikbox-details tikbox-container"
        style={{ display: show ? 'block' : 'none', marginTop: 0 }}>
        <div className="tikbox-row">
          <RegisterUserForm
            activeCycle={activeCycle}
            currentPlan={currentPlan}
            setRegisterFormData={setRegisterFormData}
            changeActive={changeActive}
            setBillingMemberCount={setBillingMemberCount}
          />

          <BillingCycle
            activeCycle={activeCycle}
            changeActiveCycle={changeActiveCycle}
            plan={currentPlan}
            activeProduct={activeProduct}
            billingMemberCount={billingMemberCount}
          />
        </div>
      </div>
    </>
  )
}

export default OrderSummary
